
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 0a1 1 0 100 2v8a2 2 0 002 2h4v4H6a1 1 0 100 2h4a1 1 0 100-2H9v-4h4a2 2 0 002-2V2a1 1 0 100-2H1zm10.82 5.314a.854.854 0 00-.057-1.114.658.658 0 00-1 .064L9.266 6.14a.219.219 0 01-.318.036L7.712 5.144c-.63-.527-1.504-.485-2.09.1L4.235 6.621a.854.854 0 00-.056 1.114.658.658 0 001 .063l1.384-1.378a.218.218 0 01.299-.014l1.234 1.032c.687.574 1.654.466 2.225-.249l1.499-1.876z","fill":"#348EF6"}})])
          )
        }
      }
    